import { queryOptions } from "@tanstack/react-query";

import { getCoachStatus } from "~/lib/functions/coach-status";

export function coachStatusQueryOptions(userId: string | undefined) {
  return queryOptions({
    queryKey: ["coach-status", userId],
    queryFn: () => getCoachStatus(),
    // Tier-1 approval gates what the coach can see. It's a cheap single-row
    // lookup and changes out-of-band (an admin approves in a different session,
    // so no invalidation can reach this client). Keep it always-revalidate —
    // a long staleTime freezes a just-approved coach on "under review" for the
    // whole session because the always-mounted sidebar observer keeps this
    // query alive and nothing triggers a refetch (issue #900).
    staleTime: 0,
    enabled: !!userId,
  });
}
